import { createContext, useContext } from 'react';

// Lifts the list "search" term out of the framework <Form> so it can live in the L1
// TopNav (deal provider chrome) instead of inside the form. The L1 search box writes
// `term`; MultipleItemsContainer merges it into the filter input; ContainerHeader drops
// the in-form search field. `active` is false by default, so apps without the provider
// (feel, deal admin) keep the search inside the form and are unaffected.
//
// `hasSearch` lets the L1 chrome show the search box only when the current page actually
// has a searchable list (ContainerHeader registers it).
//
// `hasFilters` is the same idea for the L3 SubHeader's filter zone — registered by
// HeaderFilters/ContainerHeader whenever they portal filter controls in. SubHeader reads
// `hasSearch || hasFilters` to decide whether it has anything to show at all, collapsing
// to zero height on pages with neither (see SubHeader.js).
export const ProviderSearchContext = /*#__PURE__*/createContext({
  active: false,
  term: '',
  setTerm: () => {},
  hasSearch: false,
  setHasSearch: () => {},
  hasFilters: false,
  setHasFilters: () => {}
});
export const useProviderSearch = () => useContext(ProviderSearchContext);